import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Row, Col, Form, Input, FormInstance, Select } from 'antd';

import FloatingFormItem from '@/components/_common/FloatingFormItem';
import { ReportManufacturersFormValues } from '@/core/domain/reports/stock/Report.types';

interface Props {
  form?: FormInstance<ReportManufacturersFormValues>;
}

function ManufacturersReportForm({ form }: Props) {
  const intl = useIntl();

  const from = Form.useWatch('initialWord', form);

  useEffect(() => {
    if (from === '') {
      form?.setFieldValue('finalWord', '');
    }
  }, [from]);

  return (
    <Form form={form}>
      <Row gutter={[8, 8]}>
        <Col xs={24} md={18}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'manufacturers.modal.report.form.description',
            })}
            name="name"
          >
            <Input />
          </FloatingFormItem>
        </Col>

        <Col xs={24} md={6}>
          <FloatingFormItem
            name="active"
            label={intl.formatMessage({
              id: 'commons.entity.situation',
            })}
          >
            <Select allowClear style={{ width: '100%' }}>
              <Select.Option value="true">
                <FormattedMessage id="commons.entity.active" />
              </Select.Option>
              <Select.Option value="false">
                <FormattedMessage id="commons.entity.inactive" />
              </Select.Option>
            </Select>
          </FloatingFormItem>
        </Col>

        <Col xs={24} md={12}>
          <FloatingFormItem name="initialWord" label="De:">
            <Input />
          </FloatingFormItem>
        </Col>

        <Col xs={24} md={12}>
          <FloatingFormItem name="finalWord" label="Até:">
            <Input disabled={!from} />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}

export default ManufacturersReportForm;
